import LightbulbIcon from '../icons/lightbulb.jsx';
import SendIcon from '../icons/send.jsx';
import SparklesIcon from '../icons/sparkles.jsx';
import SummaryIcon from '../icons/summary.jsx';

/** Map App icons. */
const appIconsMap = {
  outline: {
    lightbulb: LightbulbIcon,
    send: SendIcon,
    sparkles: SparklesIcon,
    summary: SummaryIcon,
  },

  fill: {},
};

export default appIconsMap;
